import OriginalModal from './Modal.svelte';
import Backdrop from './Backdrop.svelte';
import OriginalContent from './Content.svelte';
import Header from './Header.svelte';
import Body from './Body.svelte';
import Footer from './Footer.svelte';
const Modal = OriginalModal;
Modal.Backdrop = Backdrop;
Modal.Content = OriginalContent;
Modal.Content.Header = Header;
Modal.Content.Body = Body;
Modal.Content.Footer = Footer;
export default Modal;
